uic-footer {
  align-items: center;
  background-color: var(--uic-color-blue4);
  display: flex;
  justify-content: space-between;
  padding: 0 4px;

  .uic-footer__container {
    display: flex;

    &:not(:last-child) {
      margin-right: -4px;
    }
  }

  .uic-footer__container {
    > uic-button {
      &:not(:first-child) {
        padding-left: 6px;
      }

      &:not(:last-child) {
        padding-right: 6px;
      }
    }

    /* stylelint-disable selector-max-compound-selectors -- Button inside menu footer requires correct padding */

    > uic-menu-footer {
      &:not(:first-child) uic-button[slot='button'] {
        padding-left: 6px;
      }

      &:not(:last-child) uic-button[slot='button'] {
        padding-right: 6px;
      }
    }

    /* stylelint-enable selector-max-compound-selectors */
  }

  @media #{$breakpoint_tablet} {
    height: 52px;
    min-height: 52px;
  }

  @media #{$breakpoint_desktop} {
    height: 62px;
    min-height: 62px;
  }

  @media #{$breakpoint_tablet_small} {
    height: 39px;
    min-height: 39px;
  }
}
